 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"main": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"main": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + "912250be" + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-011b5a00":1,"chunk-a720a308":1,"chunk-f74b990e":1,"chunk-69594ca6":1,"chunk-2cb1e2e0":1,"chunk-6054cbd6":1,"chunk-b434c738":1,"chunk-b599de7c":1,"chunk-b658f75a":1,"chunk-022cc1d6":1,"chunk-189de59b":1,"chunk-6ef96378":1,"chunk-5e8ef5db":1,"chunk-d6eb4ef0":1,"chunk-079f4170":1,"chunk-0b680832":1,"chunk-0d39b22b":1,"chunk-16bf5b94":1,"chunk-1e675b4e":1,"chunk-22d9eb73":1,"chunk-23995260":1,"chunk-25e53f1d":1,"chunk-2807009f":1,"chunk-0e2d27f7":1,"chunk-34fd8d8c":1,"chunk-039715a0":1,"chunk-2e2142ee":1,"chunk-39334edf":1,"chunk-4685d16d":1,"chunk-46f10a06":1,"chunk-49986e30":1,"chunk-4fe09855":1,"chunk-50fec2ce":1,"chunk-58477149":1,"chunk-5cdcb26f":1,"chunk-7dbcfdce":1,"chunk-5efcaf5c":1,"chunk-00d651b6":1,"chunk-0e6c767a":1,"chunk-5376796a":1,"chunk-588dd96c":1,"chunk-e9f58144":1,"chunk-1f89963f":1,"chunk-2581797a":1,"chunk-014a4348":1,"chunk-fb443fd6":1,"chunk-35caae74":1,"chunk-54f72630":1,"chunk-669889a0":1,"chunk-66abcc7c":1,"chunk-67ce49af":1,"chunk-68095730":1,"chunk-6ac6dfb7":1,"chunk-6d2a8c1f":1,"chunk-6f9f780f":1,"chunk-77bfa1c1":1,"chunk-bb36191e":1,"chunk-7e3cb04c":1,"chunk-867a5fba":1,"chunk-9a4eda4a":1,"chunk-b3e21fb0":1,"chunk-b78c766e":1,"chunk-c71b6f4e":1,"chunk-ce438688":1,"chunk-e0389fa8":1,"chunk-e361ab1a":1,"chunk-eace658e":1,"chunk-ed074328":1,"chunk-edfa5440":1,"chunk-f87346ac":1,"chunk-fea8b3c0":1,"chunk-8d8191c6":1,"chunk-6e035552":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-011b5a00":"11753812","chunk-2d0b2ee5":"31d6cfe0","chunk-023fb868":"31d6cfe0","chunk-47968688":"31d6cfe0","chunk-a720a308":"f54bcfc4","chunk-f74b990e":"121718fe","chunk-69594ca6":"cf6f02ee","chunk-2cb1e2e0":"a37fda7d","chunk-6054cbd6":"4388eec8","chunk-b434c738":"1aa95af5","chunk-b599de7c":"d98ee656","chunk-b658f75a":"f1af8381","chunk-022cc1d6":"f4d86da9","chunk-189de59b":"42ea7477","chunk-6ef96378":"3f89b331","chunk-7da8889c":"31d6cfe0","chunk-5e8ef5db":"b9932683","chunk-d6eb4ef0":"f79afc12","chunk-079f4170":"ae4b4fe9","chunk-0b680832":"b27de552","chunk-0c7b2c68":"31d6cfe0","chunk-0d39b22b":"8c954e9f","chunk-16bf5b94":"a9f81cf9","chunk-1e675b4e":"6fe7b18f","chunk-22d9eb73":"362db2b1","chunk-23995260":"8ca1fb2b","chunk-25e53f1d":"fadb88c8","chunk-2807009f":"708df92c","chunk-0e2d27f7":"c92d46ec","chunk-34fd8d8c":"1f5e40a2","chunk-039715a0":"d7c92026","chunk-2d0c8206":"31d6cfe0","chunk-2d0e9702":"31d6cfe0","chunk-2d0e991a":"31d6cfe0","chunk-2d0f028e":"31d6cfe0","chunk-2d20e788":"31d6cfe0","chunk-2d2160f1":"31d6cfe0","chunk-2d229afb":"31d6cfe0","chunk-2e2142ee":"17626e31","chunk-39334edf":"6fe7b18f","chunk-4463fdfe":"31d6cfe0","chunk-4685d16d":"9f47403a","chunk-46f10a06":"81c7bc06","chunk-49986e30":"37387831","chunk-4fe09855":"fba66d09","chunk-50fec2ce":"4184c91a","chunk-58477149":"b27de552","chunk-5cdcb26f":"fadc5cfe","chunk-7dbcfdce":"2b77c424","chunk-5efcaf5c":"3e15804f","chunk-619d7aac":"31d6cfe0","chunk-00d651b6":"b7e7ae6c","chunk-0e6c767a":"bcefc8ee","chunk-5376796a":"b7853ad8","chunk-588dd96c":"63d98c3a","chunk-e9f58144":"92977f72","chunk-1f89963f":"f443ba41","chunk-2581797a":"65f2a5b2","chunk-014a4348":"529c81fa","chunk-fb443fd6":"182a594f","chunk-35caae74":"c346668a","chunk-54f72630":"284eb59a","chunk-669889a0":"0eda985e","chunk-66abcc7c":"413c7d02","chunk-67ce49af":"85d9b216","chunk-68095730":"8556c6c5","chunk-6ac6dfb7":"bd011eb2","chunk-6d2a8c1f":"0fb5ef4a","chunk-6f9f780f":"a146c01a","chunk-77bfa1c1":"6a399009","chunk-bb36191e":"8162e8ec","chunk-7e3cb04c":"8e9de4e5","chunk-867a5fba":"3f5c4090","chunk-9a4eda4a":"70d243d9","chunk-b3e21fb0":"0a642f9b","chunk-b78c766e":"6fe7b18f","chunk-c71b6f4e":"92d24154","chunk-ce438688":"3e15804f","chunk-cf3b0bda":"31d6cfe0","chunk-e0389fa8":"f71682ce","chunk-e361ab1a":"4338a410","chunk-eace658e":"00070bb4","chunk-ed074328":"830204b7","chunk-2d0ae9a7":"31d6cfe0","chunk-edfa5440":"884ed30c","chunk-f87346ac":"3fdb2255","chunk-fea8b3c0":"7806db4f","chunk-8d8191c6":"9ade32d0","chunk-6e035552":"5097c81c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "//cdnstatic.gamekee.com/wiki/4.0/pc/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push(["a949","chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
